:host{width:100%;background:#fbfbfb}:host .details-pane{height:100%;display:grid;padding:8px;overflow-y:scroll;grid-template-columns:auto;column-gap:16px;row-gap:4px;align-content:start}
/*# sourceMappingURL=tag-pane.component.css.map */
